import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "작성일", "임명장첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: list.getHead()[0].key, operator: "=", value: search.year });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    conditions.push(...SearchColumnKeyword.methods.getConditions(nav, "column", heads));
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "임명장첨부",
        key: "",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      let i = 0;
      if (index === i++) {
        // 대상년도
        const header = JSON.parse(value.post_content).header;
        return header.year;
      }
      if (index === i++) return func.getContent(value).stdInfo.field_name; // 사업장명
      if (index === i++) return func.getContent(value).stdInfo.section; // 부서명
      if (index === i++) return func.getContent(value).stdInfo.department; // 소속명
      if (index === i++) return func.getContent(value).stdInfo.writer_name; // 작성자
      if (index === i++) return func.getCreatedDate(value.created_at); // 작성일
      if (index === i++) return {
        type: "file",
        files: func.getContent(value).fileList,
      }; // 임명장첨부
    } catch (e) {}
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
};
export default list;
